
//const staticURL="https://localhost/carlos/";
const staticURL="https://csosadesignco.com/wordpress/";
//export const staticRemote = "https://localhost/carlos/";

export default staticURL;